'use strict';

module.exports = ['$scope', '$rootScope', '$http', '$auth', '$uibModal', function($scope, $rootScope, $http, $auth, $uibModal) {
	$scope.authenticate = function(provider) {
		$auth.authenticate(provider)
			.catch(function(response) {
				if (response == "Error: The popup window was closed")
					return;

				if (response.status == 401) {
					//alert('That login is not authorised to access this app.');
					var childScope = $scope.$new();
					childScope.title = "Unauthorised";
					childScope.body = "That login is not authorised to access this app.";
					var dialog = $uibModal.open({
						templateUrl: 'genericok.html',
						scope: childScope
					});
					/*dialog.result.then(function(result) {
						//console.log('dialog', result);
						// Reload the page
	               		window.location = getAbsoluteUrl("login");
					});*/
				} else {
					alert('Something went wrong.');
					console.log(response);
				}
			});
    };
	
	$scope.isAuthenticated = function() {
		return $auth.isAuthenticated();
	};
	
	$scope.logout = function() {
		$auth.logout();
	};
	
	// Get profile on load
	$scope.$watch('isAuthenticated()', function(newVal, oldVal) {
		if (newVal) {
			$scope.profile = $auth.getPayload();
			$rootScope.token = $auth.getToken();
			$rootScope.$broadcast('loginChanged');
		} else {
			$scope.profile = null;
			$rootScope.token = null;
			$rootScope.$broadcast('loginChanged');
		}
	});
}];
